import { render } from "./RichTextRenderer.vue?vue&type=template&id=d2ce6ace"
import script from "./RichTextRenderer.vue?vue&type=script&lang=js"
export * from "./RichTextRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__